import { hc } from "hono/client";

import { type AppType } from "@/app";

// assign the client to a variable to calculate the type when compiling
const _client = hc<AppType>("");
type ClientShape = typeof _client;
// An interface, so consumers' inferred types refer to it by name instead of
// spelling out the whole route tree (which exceeds TS's serialization limit).
// oxlint-disable-next-line typescript/no-empty-object-type
export interface Client extends ClientShape {}

export const hcWithType = (...args: Parameters<typeof hc>): Client =>
  hc<AppType>(...args);

export { InferRequestType } from "hono/client";
